import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpods: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAirpods"><Path d="M16.5 13.083V20.5H13.5V8.5C13.5 5.73858 15.7386 3.5 18.5 3.5C19.6257 3.5 20.6643 3.87223 21.5 4.5V12.499C20.6642 13.127 19.6259 13.5 18.5 13.5C17.7888 13.5 17.1126 13.3507 16.5 13.083ZM16.5 13.083V11" stroke="currentColor"/><Path d="M7.5 13.083V20.5H10.5V8.5C10.5 5.73858 8.26142 3.5 5.5 3.5C4.37432 3.5 3.33569 3.87223 2.5 4.5V12.499C3.33577 13.127 4.3741 13.5 5.5 13.5C6.21124 13.5 6.88745 13.3507 7.5 13.083ZM7.5 13.083V11" stroke="currentColor"/></CentralIconBase>;
});

export default IconAirpods;
